import Link from '@scandipwa/scandipwa/src/component/Link';
import {
    SearchItemComponent as SourceSearchItemComponent,
} from 'SourceComponent/SearchItem/SearchItem.component';
import React from 'react';
import './SearchItem.override.style';

export class SearchItemComponent extends SourceSearchItemComponent {
    renderLink() {
        const { linkTo, onClick, product: { sku } } = this.props;

        const link = sku?.toLowerCase();

        return (
            <Link
                block="SearchItem"
                elem="Link"
                to={`${link}.html`}
                onClick={onClick}
            >
                <figure className="SearchItem-Wrapper">
                    {this.renderImage()}
                    {this.renderContent()}
                </figure>
            </Link>
        );
    }
}

export default SearchItemComponent;
